import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getFinanceReponse, getYearOptions, getYearValue } from '../licenseAnalyticsSupport/getLicenseAnalyticsActions';
import MultiSelectDropdown from '../MultiSelectComponent/MultiSelectPrimary/selectDropDownComponent';
import { SingleOption } from '../licenseAnalyticsSupport/typeInterfaces';
import { useTranslation } from 'react-i18next';
import { setYearOptions, setYearValue } from '../../../redux/reducers/licenceAnalytics';

const getYearList = (response: { year: string | number }[]): SingleOption[] => {
  const resultArr: SingleOption[] | any = [];
  // Extracting unique years without using Set/spread to avoid downlevel-iteration issues
  const yearValues: (string | number)[] = response.map((item) => item.year);
  const uniqueYears: (string | number)[] = yearValues.filter((year, index, arr) => arr.indexOf(year) === index);
  // Converting to the desired format
  uniqueYears.forEach((year) => resultArr.push({ id: year.toString(), name: year.toString() }));
  return resultArr.reverse();
};

const YearFilterComponent: React.FC = () => {
  const dispatch = useDispatch();
  const [t] = useTranslation();
  const yearOptions: SingleOption[] = useSelector(getYearOptions);
  const value: SingleOption | undefined = useSelector(getYearValue);
  const financeResponse: any = useSelector(getFinanceReponse);
  const [isConstructOptions, setConstructOptions] = useState(true);

  useEffect(() => {
    if (isConstructOptions && financeResponse?.length > 0) {
      const options = getYearList(financeResponse);
      dispatch(setYearOptions({ options }));
      setConstructOptions(false);
    }
  }, [financeResponse]);

  const onChange = (newValue: SingleOption | undefined): void => {
    dispatch(setYearValue({ newValue }));
  };

  return (
    <MultiSelectDropdown
      title={t('YEAR')}
      options={yearOptions}
      value={value}
      onChange={onChange}
      width="100%"
      rootCss={{ width: '100%' }}
    />
  );
};

export default YearFilterComponent;
